<template>
<div>
    <v-giftevm v-if="chainId == 9001"></v-giftevm>
    <v-giftzkmain v-if="chainId == 324"></v-giftzkmain>
    <v-giftscrollmain v-if="chainId == 534352"></v-giftscrollmain>
</div>
</template>

<script>
    export default {
        data() {
            return {
                chainId:'',
            }
        },
        mounted(){
            this.chainId = localStorage.getItem('chainId') || 9001
            if (this.chainId == 534351) {
                this.$router.push({path:'/home'})
                // window.location.reload();
            }
        },
    }
</script> 